import { ref, computed, watch } from 'vue'

export type ThemeMode = 'light' | 'dark' | 'system'

export const useDarkMode = () => {
  const colorMode = useColorMode()
  
  const isDark = computed(() => colorMode.value === 'dark')
  
  const toggleDarkMode = () => {
    colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
  }
  
  const setTheme = (theme: ThemeMode) => {
    colorMode.preference = theme
  }
  
  return {
    isDark,
    currentTheme: computed(() => colorMode.preference as ThemeMode),
    toggleDarkMode,
    setTheme
  }
}
